<template>
    <table class="table table-sm color">
        <caption class="caption table-caption">Deal Information</caption>
        <tbody>
            <tr>
                <th class="text-left font-weight-normal">Issue Date</th>
                <td class="text-right">{{issueDate}}</td>
            </tr>
            <tr>
                <th class="text-left font-weight-normal">Factor Date</th>
                <td class="text-right">{{factorDate}}</td>
            </tr>
            <tr>
                <th class="text-left font-weight-normal">1st Projected Date</th>
                <td class="text-right">{{firstProjectedDate}}</td>
            </tr>
            <tr>
                <th class="text-left font-weight-normal">Maturity Date</th>
                <td class="text-right">{{maturityDate}}</td>
            </tr>
            <tr>
                <th class="text-left font-weight-normal">{{dealName.startsWith('ACIS') ? 'Early' : 'Cleanup'}} Call Date</th>
                <td class="text-right">{{earlyRedemptionDate}}</td>
            </tr>
            <tr v-if="dealName.startsWith('STACR') || dealName.startsWith('CAS')">
                <th class="text-left font-weight-normal">Cleanup Call Percentage</th>
                <td class="text-right">{{earlyRedemptionPct}}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
  props: [
    'dealName',
    'issueDate',
    'factorDate',
    'firstProjectedDate',
    'maturityDate',
    'earlyRedemptionPct',
    'earlyRedemptionDate'
  ]
}
</script>
